export var KlevuTypeOfRecord;
(function (KlevuTypeOfRecord) {
    KlevuTypeOfRecord["Product"] = "KLEVU_PRODUCT";
    KlevuTypeOfRecord["Cms"] = "KLEVU_CMS";
    KlevuTypeOfRecord["Category"] = "KLEVU_CATEGORY";
})(KlevuTypeOfRecord || (KlevuTypeOfRecord = {}));
